module.exports = __webpack_public_path__ + "pc/img/about-global-map.da23069a.png";